import { css } from '@/styled-system/css';

export const content = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'loose',
  paddingBlock: 'default',
});

export const mobileOnlyModule = css({
  lg: {
    display: 'none',
  },
});

export const contentStack = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const unitGroups = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'layout.tight',
});

export const unitGroup = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const unitGroupHeader = css({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto',
  gap: 'default',
  alignItems: 'start',
});

export const unitCardsGrid = css({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr)',
  gap: 'default',
  lg: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 'loose',
  },
});

export const emptyState = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
  padding: 'loose',
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'border.neutral',
  borderRadius: 'md',
  background: 'bg.softest',
});

export const breadcrumbsNav = css({
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});

export const breadcrumbsList = css({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 'tightest',
  listStyle: 'none',
  margin: 0,
  padding: 0,
});

export const breadcrumbItem = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tightest',
});

export const breadcrumbSeparator = css({
  color: 'text.subtle',
  userSelect: 'none',
});

export const footerWrapper = css({
  marginTop: 'layout.default',
});
